import type { OptionItemType, BtnItemType } from './type'
import {
  Operation,
  TabsType,
  ApplicableResourcesType,
  AuditStatusType,
} from './enums'
import { SkeletonType } from '@com/enums/model'

export const tabMapOptions: OptionItemType[] = [
  {
    label: '全部',
    value: TabsType.ALL,
  },
  {
    label: '龙骨',
    value: TabsType.KEEL,
  },
  {
    label: '视频',
    value: TabsType.VIDEO,
  },
  {
    label: '图片',
    value: TabsType.PICTURE,
  },
  {
    label: '动图',
    value: TabsType.GRAPH,
  },
  {
    label: '音频',
    value: TabsType.AUDIO,
  },
  {
    label: '粒子',
    value: TabsType.PARTICLE,
  },
  {
    label: '字体',
    value: TabsType.FONT,
  },
  {
    label: '花字',
    value: TabsType.FLOWERWORD,
  },
  {
    label: '转场',
    value: TabsType.TRANSITION,
  },
  {
    label: '滤镜',
    value: TabsType.FILTER,
  },
  {
    label: '动画',
    value: TabsType.ANIMATION,
  },
  {
    label: '预设',
    disabled: false,
    value: TabsType.PRESETS,
  },
  {
    label: '片段',
    disabled: false,
    value: TabsType.FRAGMENT,
  },
  {
    label: '模型',
    disabled: false,
    value: TabsType.MODEL,
  },
  {
    label: '动作',
    disabled: false,
    value: TabsType.ACTION,
  },
]

export const resourcesList: OptionItemType[] = [
  {
    label: '资源名称',
    value: 'name',
  },
  {
    label: '资源id',
    value: 'id',
  },
  {
    label: '资源描述',
    value: 'description',
  },
]

export const orderOptions: OptionItemType[] = [
  { label: '工单ID', value: 'id' },
  { label: '项目ID', value: 'project_id' },
  { label: '模型名称', value: 'material_name' },
]

export const statusOptions: OptionItemType[] = [
  {
    label: '未上架',
    value: 1,
  },
  {
    label: '已上架',
    value: 2,
  },
  {
    label: '下架',
    value: 3,
  },
]

export const copyrightOptions: OptionItemType[] = [
  {
    label: '无商业版权',
    value: 1,
  },
  {
    label: '有商业版权但无额外授权',
    value: 2,
  },
  {
    label: '有商业版权且有额外授权',
    value: 3,
  },
  {
    label: '未知',
    value: 4,
  },
]

export const sourceOptions: OptionItemType[] = [
  {
    label: '内部',
    value: 1,
  },
  {
    label: '外部购买',
    value: 2,
  },
]

export const publicOptions: OptionItemType[] = [
  {
    label: '是，外部可用',
    value: 1,
  },
  {
    label: '否，仅内部使用',
    value: 2,
  },
]

export const applicableOptions: OptionItemType[] = [
  {
    label: '可玩工具',
    value: 1,
  },
  {
    label: '视频工具',
    value: 2,
  },
  {
    label: '录屏工具',
    value: 3,
  },
]

export const videoApplicableOptions: OptionItemType[] = [
  {
    label: '视频工具',
    value: 2,
  },
]

export const skeletonOptions: OptionItemType[] = [
  {
    label: '人形骨骼',
    value: SkeletonType.HUMANOID,
  },
  {
    label: '鱼类骨骼',
    value: SkeletonType.FISH,
  },
  {
    label: '爬行类骨骼',
    value: SkeletonType.REPTILIA,
  },
  {
    label: '鸟类骨骼',
    value: SkeletonType.BIRD,
  },
  {
    label: '蛇类骨骼',
    value: SkeletonType.SNAKE,
  },
  {
    label: '简易骨骼',
    value: SkeletonType.SIMPLE,
  },
  {
    label: '地面',
    value: SkeletonType.SURFACE,
  },
  {
    label: '/',
    value: SkeletonType.BLANK,
  },
  {
    label: '无骨骼',
    value: SkeletonType.NOT,
  },
]

export const realizeOptions: OptionItemType[] = [
  {
    label: '2D PS粒子',
    value: 1,
  },
  {
    label: '3D Unity粒子',
    value: 2,
  },
  {
    label: '3D laya粒子',
    value: 3,
  },
  {
    label: '2D laya粒子',
    value: 4,
  },
  {
    label: '3D cocos粒子',
    value: 5,
  },
]

export const flowerWordOptions: OptionItemType[] = [
  {
    label: '花字',
    value: 1,
  },
  {
    label: '字体预设',
    value: 2,
  },
]

export const applicableResourcesOptions: OptionItemType[] = [
  {
    label: '视频、图片',
    value: ApplicableResourcesType.VIDEOPICTURE,
  },
  // {
  //   label: '贴纸',
  //   value: ApplicableResourcesType.TAG,
  // },
  {
    label: '文字',
    value: ApplicableResourcesType.TEXT,
  },
]

export const animationOptions: OptionItemType[] = [
  {
    label: '入场',
    value: 1,
  },
  {
    label: '出场',
    value: 2,
  },
  {
    label: '组合',
    value: 3,
  },
  {
    label: '循环',
    value: 4,
  },
]
export const animationTypesOption: { [key: number]: OptionItemType[] } = {
  [ApplicableResourcesType.VIDEOPICTURE]: [
    {
      label: '入场',
      value: 1,
    },
    {
      label: '出场',
      value: 2,
    },
    {
      label: '组合',
      value: 3,
    },
  ],
  [ApplicableResourcesType.TAG]: [
    {
      label: '入场',
      value: 1,
    },
    {
      label: '出场',
      value: 2,
    },
    {
      label: '循环',
      value: 4,
    },
  ],
  [ApplicableResourcesType.TEXT]: [
    {
      label: '入场',
      value: 1,
    },
    {
      label: '出场',
      value: 2,
    },
    {
      label: '循环',
      value: 4,
    },
  ],
}

export const btnOption: BtnItemType[] = [
  {
    name: '删除',
    type: Operation.BATCHDE,
  },
  {
    name: '下载',
    type: Operation.DOWNLOAD,
  },
  {
    name: '是否公开',
    value: '1',
    type: Operation.ISOPEN,
  },
  {
    name: '上下架',
    value: '2',
    type: Operation.UPLOW,
  },
  {
    name: '修改版权',
    value: '1',
    type: Operation.COPYRIGHT,
  },
]

export const auditStatusOption: OptionItemType[] = [
  {
    label: '编辑中',
    value: AuditStatusType.edit,
  },
  {
    label: '已提交，待审核',
    value: AuditStatusType.waitReview,
  },
  {
    label: '渲染中',
    value: AuditStatusType.review,
  },
  {
    label: '渲染失败',
    value: AuditStatusType.review_failed,
  },
  {
    label: '审核通过',
    value: AuditStatusType.approved,
  },
  {
    label: '审核不通过',
    value: AuditStatusType.rejected,
  },
]

export const showStatusOption: OptionItemType[] = [
  {
    label: '未上架',
    value: 1,
  },
  {
    label: '已上架',
    value: 2,
  },
]

export const moreBtnOption: BtnItemType[] = btnOption.concat([
  {
    name: '应用范围',
    value: '',
    type: Operation.APPLICABLETOOL,
  },
  { name: '添加标签', type: Operation.ADDLABEL },
  { name: '移除标签', type: Operation.DELABEL },
])

export const auditBtnOption: BtnItemType[] = [
  {
    name: '修改标签',
    value: '',
    type: Operation.TAGS,
  },
  {
    name: '审核通过/审核拒绝',
    value: 'approved',
    type: Operation.AUDIT,
  },
]

export const particleCaasOption: BtnItemType = {
  name: '下载粒子(caas)',
  value: 'fixParticlePath',
  type: Operation.DOWNLOAD,
}

export const accessAllowOptions: { label: string; value: boolean }[] = [
  { value: false, label: '应用到所有' },
]
